import { render, staticRenderFns } from "./dialog-volumediscount.vue?vue&type=template&id=560f52f8&"
import script from "./dialog-volumediscount.vue?vue&type=script&lang=js&"
export * from "./dialog-volumediscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports